import { Box, Grid2, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSiteRatings, selectIfSiteRatingsLoading, selectSiteRatings } from '../../store/slices/emergingAlertsSlice';
import { AppDispatch } from '../../store/store';
import PiorityDeviationsBackground from '../../assets/priority-highlights.svg';
import { GET_ESCALATION_COLOR } from '../../constants/SeverityColors';
import AdnocLoadingProgress from '../shared/AdnocLoadingProgress';
import React from 'react';

const siteRatingsAreasComparersFn = (first: any, second: any) => {
    const firstCount = first.high_areas + first.high_medium_areas + first.medium_areas + first.low_areas
    const secondCount = second.high_areas + second.high_medium_areas + second.medium_areas + second.low_areas
    return secondCount - firstCount;
}

export default function PriorityDeviations() {
    const dispatch = useDispatch<AppDispatch>();

    const isSiteRatingsLoading = useSelector(selectIfSiteRatingsLoading);
    const siteRatings = useSelector(selectSiteRatings);

    const renderSiteRatings = useMemo(() => {
        const h = siteRatings.filter((sr: any) => sr.site_rating.toLowerCase() === 'high');
        const hm = siteRatings.filter((sr: any) => sr.site_rating.toLowerCase() === 'high-medium');
        const m = siteRatings.filter((sr: any) => sr.site_rating.toLowerCase() === 'medium');
        return [
            ...h.sort(siteRatingsAreasComparersFn),
            ...hm.sort(siteRatingsAreasComparersFn),
            ...m.sort(siteRatingsAreasComparersFn)
        ]
    }, [siteRatings])

    useEffect(() => {
        if (isSiteRatingsLoading === null)
            dispatch(getSiteRatings())
    }, [dispatch, isSiteRatingsLoading])

    return (
        <Grid2 sx={{
            background: `url('${PiorityDeviationsBackground}') no-repeat`,
            backgroundPosition: 'top right',
            backgroundSize: 'cover',
            paddingTop: '1.25vw',
            paddingRight: '1.25vw'
        }}>
            <Box
                sx={{
                    paddingX: 2,
                    paddingY: 1,
                    borderTopRightRadius: '0.5vw',
                    background: 'linear-gradient(to left, #E1E1E1FF 20%, #FFFFFF00 80%)'
                }}>
                <Typography variant='h6' textTransform={'capitalize'}>
                    Sites with Most Asset Integrity Deviations
                </Typography>
                <Typography variant='body2' textTransform={'uppercase'} color='#002B64'>
                    AS OF TODAY, {dayjs().format('MMMM DD, h:mm A')}
                </Typography>
            </Box>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                rowGap: 0.5,
                textAlign: 'center',
                '& :nth-of-type(-n+3)': {
                    paddingY: 0.5,
                    color: '#002B64',
                    fontWeight: 500,
                },
                '& :nth-of-type(n+4)': {
                    padding: 0.75,
                    background: 'var(--text-light)',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                },
                '& .site': {
                    background: '#18FEFE38'
                },
            }}>
                <Typography variant='body2' textTransform={'uppercase'} >
                    Escalation Priority
                </Typography>
                <Typography variant='body2' textTransform={'uppercase'} >
                    Site
                </Typography>
                <Typography variant='body2' textTransform={'uppercase'} >
                    Total Deviated Areas
                </Typography>
                {
                    isSiteRatingsLoading === true && <Box sx={{
                        gridColumn: '1/-1',
                        background: 'transparent !important',
                        padding: 1
                    }}>
                        <AdnocLoadingProgress></AdnocLoadingProgress>
                    </Box>
                }
                {
                    renderSiteRatings.length > 0 && renderSiteRatings.map((sr: any, index: number) => {
                        return <React.Fragment key={index}>
                            <Typography key={`sr-${index}`} variant='body1' sx={{
                                borderLeft: `0.25vw solid ${GET_ESCALATION_COLOR(sr.site_rating)}`
                            }}>
                                {sr.site_rating}
                            </Typography>
                            <Typography key={`sn-${index}`} variant='body1' className='site'>
                                {sr.site_name}
                            </Typography>
                            <Typography key={`sha-${index}`} variant='body1'>
                                {sr.high_areas + sr.high_medium_areas + sr.medium_areas + sr.low_areas}
                            </Typography>
                        </React.Fragment>
                    })
                }
            </Box>
        </Grid2>
    )
}
